export default {
  memory: {},
  memoryLoading: false,
  submitLoading: false,
};
